module.exports = __webpack_public_path__ + "img/figure-7.6091c6b3.png";